"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _toArray = _interopRequireDefault(require("rc-util/lib/Children/toArray"));
var _omit = _interopRequireDefault(require("omit.js"));
var _Select = _interopRequireDefault(require("../Select"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var Option = _Select.default.Option;
var InputStatuses = ['warning', 'error', ''];
function isSelectOptionOrSelectOptGroup(child) {
  return child && child.type && (child.type.isSelectOption || child.type.isSelectOptGroup);
}
var AutoComplete = function AutoComplete(props, ref) {
  var prefixCls = props.prefixCls,
    className = props.className,
    popupClassName = props.popupClassName,
    dropdownClassName = props.dropdownClassName,
    children = props.children,
    dataSource = props.dataSource;
  var childNodes = (0, _toArray.default)(children);

  // ============================= Input =============================
  var customizeInput;
  if (childNodes.length === 1 && /*#__PURE__*/(0, _react.isValidElement)(childNodes[0]) && !isSelectOptionOrSelectOptGroup(childNodes[0])) {
    var _childNodes = (0, _slicedToArray2.default)(childNodes, 1);
    customizeInput = _childNodes[0];
  }
  var getInputElement = customizeInput ? function () {
    return customizeInput;
  } : undefined;

  // ============================ Options ============================
  var optionChildren;

  // [Legacy] convert `children` or `dataSource` into option children
  if (childNodes.length && isSelectOptionOrSelectOptGroup(childNodes[0])) {
    optionChildren = children;
  } else {
    optionChildren = dataSource ? dataSource.map(function (item) {
      if (/*#__PURE__*/(0, _react.isValidElement)(item)) {
        return item;
      }
      switch ((0, _typeof2.default)(item)) {
        case 'string':
          return /*#__PURE__*/_react.default.createElement(Option, {
            key: item,
            value: item
          }, item);
        case 'object':
          {
            var _ref = item,
              optionValue = _ref.value;
            return /*#__PURE__*/_react.default.createElement(Option, {
              key: optionValue,
              value: optionValue
            }, item.label);
          }
        default:
          return undefined;
      }
    }) : [];
  }
  var getMode = (0, _react.useMemo)(function () {
    // Select.SECRET_COMBOBOX_MODE_DO_NOT_USE as SelectProps['mode']
    return 'combobox';
  }, []);
  return /*#__PURE__*/_react.default.createElement(_Select.default, (0, _extends2.default)({
    ref: ref,
    suffixIcon: null
  }, (0, _omit.default)(props, ['dataSource', 'dropdownClassName']), {
    prefixCls: prefixCls,
    popupClassName: popupClassName || dropdownClassName,
    className: (0, _classnames.default)("".concat(prefixCls, "-auto-complete"), className),
    mode: getMode
  }), optionChildren);
};
var RefAutoComplete = /*#__PURE__*/_react.default.forwardRef(AutoComplete);
RefAutoComplete.Option = Option;
RefAutoComplete.displayName = 'AutoComplete';
var _default = exports.default = RefAutoComplete;